import React from 'react';
import PicklistTableBase from '../PicklistTableBase';
import { usePicklistDetailsSelector, usePicklistPermissions } from 'hooks/Picklist';
import { assembliesTableConfig } from '../../../helpers';
import AssemblyNameCellContent from '../Cells/AssemblyNameCellContent';

export function PicklistAssemblies(props) {
  const {
    assemblies,
    filter,
    criteria: { picklistAssetStatuses }
  } = usePicklistDetailsSelector();
  const permissions = usePicklistPermissions();

  return (
    <PicklistTableBase
      {...props}
      tableData={assemblies}
      tableConfig={assembliesTableConfig}
      filter={filter}
      assetStatuses={picklistAssetStatuses}
      permissions={permissions}
      addDataLabel="Add assemblies to the picklist."
      renderNameCell={(row) => <AssemblyNameCellContent row={row} />}
    />
  );
}
